const PREFIX = 'PLANS_STATE_';

export const CLEAR_PLAN_CREATE_STATE = `${PREFIX}CLEAR_PLAN_CREATE_STATE`;
export const CLEAR_PLAN_CREATE_OR_EDIT_STATE = `${PREFIX}CLEAR_PLAN_CREATE_OR_EDIT_STATE`;
export const THROW_ERROR = `${PREFIX}THROW_ERROR`;
